/* Golden Grind Startseite (A87): Parallax-Statue, Sticky-Kapitel „The Code", Reveal per IntersectionObserver.
   Ohne Libraries, respektiert prefers-reduced-motion. */
(function () {
  var root = document.querySelector('.gg');
  if (!root) return;
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  root.classList.add('gg-js');

  // Reveal
  var reveals = root.querySelectorAll('.gg-reveal');
  if (reduced.matches || !('IntersectionObserver' in window)) {
    reveals.forEach(function (el) { el.classList.add('gg-in'); });
  } else {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('gg-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.12 });
    reveals.forEach(function (el) { io.observe(el); });
  }

  // Parallax + Kapitelwechsel
  var hero = root.querySelector('.gg-hero');
  var heroImg = root.querySelector('[data-gg-parallax="hero"]');
  var ethos = root.querySelector('[data-gg-ethos]');
  var ethosImg = root.querySelector('[data-gg-parallax="ethos"]');
  var copy = root.querySelector('.gg-ethos-copy');
  var kicker = document.getElementById('gg-ethos-kicker');
  var title = document.getElementById('gg-ethos-title');
  var text = document.getElementById('gg-ethos-text');
  var bars = root.querySelectorAll('.gg-progress i');
  var chapters = [
    { k: 'I / THE MINDSET', h: 'Greatness<br>is <em>carved.</em>', p: 'Keine Form ohne Widerstand.<br>Kein Fortschritt ohne Wiederholung.' },
    { k: 'II / THE WORK', h: 'Rep after<br><em>rep.</em>', p: 'Tag für Tag. Satz für Satz.<br>Disziplin gibt deiner Stärke eine Form.' },
    { k: 'III / THE LEGACY', h: 'The iron<br><em>never lies.</em>', p: 'Die Golden Era ist eine Haltung.<br>Und du trägst sie weiter.' }
  ];
  var lastStage = 0, scheduled = false, swapTimer;

  function setStage(stage) {
    if (stage === lastStage) return;
    lastStage = stage;
    copy.classList.add('gg-swap');
    clearTimeout(swapTimer);
    swapTimer = setTimeout(function () {
      kicker.textContent = chapters[stage].k;
      title.innerHTML = chapters[stage].h;
      text.innerHTML = chapters[stage].p;
      copy.classList.remove('gg-swap');
    }, 180);
    bars.forEach(function (b, i) { b.classList.toggle('active', i <= stage); });
  }

  function frame() {
    scheduled = false;
    if (reduced.matches) return;
    var y = window.scrollY, mobile = window.innerWidth <= 700;
    if (heroImg && hero.getBoundingClientRect().bottom > 0) {
      heroImg.style.transform = 'translateY(' + Math.min(y * 0.13, 130) + 'px) scale(' + (1 + Math.min(y / 8000, 0.06)) + ')';
    }
    if (ethos) {
      var r = ethos.getBoundingClientRect();
      if (r.bottom > 0 && r.top < window.innerHeight) {
        var p = Math.max(0, Math.min(1, -r.top / Math.max(1, ethos.offsetHeight - window.innerHeight)));
        if (ethosImg) ethosImg.style.transform = 'translateY(' + p * (mobile ? 28 : 65) + 'px) scale(' + (1 + p * 0.13) + ')';
        setStage(Math.min(2, Math.floor(p * 3)));
      }
    }
  }

  window.addEventListener('scroll', function () {
    if (!scheduled) { scheduled = true; requestAnimationFrame(frame); }
  }, { passive: true });
  window.addEventListener('resize', frame);
  reduced.addEventListener && reduced.addEventListener('change', function () {
    if (reduced.matches) {
      if (heroImg) heroImg.style.transform = '';
      if (ethosImg) ethosImg.style.transform = '';
      lastStage = -1; setStage(0);
      reveals.forEach(function (el) { el.classList.add('gg-in'); });
    } else frame();
  });
  frame();
})();
